export default {
  site: {
    login: {
      category: 'Ingreso sitio',
      action: 'btn.clic.ingreso_cuenta',
      label: '',
    },
    recover: {
      category: 'Ingreso sitio',
      action: 'link.clic.recuperacion_clave',
      label: '',
    },
    create: {
      category: 'Ingreso sitio',
      action: 'link.clic.creacion_cuenta',
      label: '',
    },
    logout: {
      category: 'Home sitio',
      action: 'btn.cierre_sesion',
      label: '',
    },
  },
  create: {
    indentify: {
      category: 'Creación de cuenta',
      action: 'btn.clic.identificacion',
      label: '',
    },
    pageindex: {
      category: 'Creación de cuenta',
      action: 'link.clic.pag_inicio',
      label: '',
    },
    personaldata: {
      category: 'Creación de cuenta',
      action: 'btn.clic.datos_personales',
      label: '',
    },
    createpass: {
      category: 'Creación de cuenta',
      action: 'btn.clic.creacion_clave',
      label: '',
    },
  },
  recover: {
    btnrecovermail: {
      category: 'Recuperacion clave',
      action: 'btn.recuperacion',
      label: 'mail',
    },
    btnrecoversms: {
      category: 'Recuperacion clave',
      action: 'btn.recuperacion',
      label: 'SMS',
    },
    btnrecoversmsecurity: {
      category: 'Recuperacion clave',
      action: 'btn.recuperacion.codigo_seguridad',
      label: 'sms',
    },
    newpassbtn: {
      category: 'Recuperacion clave',
      action: 'btn.recuperacion.ingreso_nueva_clave',
      label: '',
    },
  },
  click: {
    btnVideoLlamada: {
      category: 'Video llamada',
      action: 'link.clic.video_llamada',
    },
  },
};
